import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import de from '@/locales/de.json'

/**
 * Deutsch ist vorerst die einzige Sprache. Trotzdem läuft jeder Text hierüber -
 * dieselbe Mechanik wie in der Konsole, kein hartcodiertes Deutsch im JSX.
 */
void i18n.use(initReactI18next).init({
    resources: { de: { translation: de } },
    lng: 'de',
    fallbackLng: 'de',
    interpolation: { escapeValue: false },
    returnNull: false,
    // Ohne diese Zeile bleibt der Bildschirm weiß, solange keine
    // Suspense-Boundary um die App liegt.
    react: { useSuspense: false },
})

export default i18n
